import React from 'react';
import { AgGridReact, AgGridColumn } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';

import { ICurrencyFormat } from '../../../utils/types';
import { Container, TableWrapper } from './ProductsTable.styles';
import { useTableData } from './ProductsTable.helpers';
import { GridReadyEvent } from 'ag-grid-community';
import { Pagination } from '../Table.styles';
import { ApButtonText } from '@alixpartners/ui-components';
import { IChartOptionsConfig } from 'views/Products/types';

export const ProductsTable = ({
  chartOptionsConfig,
  format,
  isHeadcount = false,
  pageSize = 10,
  rowData,
}: {
  chartOptionsConfig: IChartOptionsConfig;
  format: ICurrencyFormat;
  isHeadcount?: boolean;
  pageSize?: number;
  rowData: any[];
}) => {
  const [gridApi, setGridApi] = React.useState<any>(null);
  const [extraRows, setExtraRows] = React.useState(0);
  const paginationPageSize = pageSize * (extraRows + 1);
  const columnDefs: any[] = useTableData(
    chartOptionsConfig,
    format,
    isHeadcount
  );
  if (!rowData || rowData.length === 0) {
    return null;
  }
  const gridOptions = {
    getRowClass: (params: any) => {
      if (params.data.isHighlighted) {
        return 'highlighted-row';
      }
      return '';
    },
    rowHeight: 24,
    rowData,
  };
  return (
    <Container>
      <TableWrapper>
        <div className="ag-theme-balham">
          <AgGridReact
            {...gridOptions}
            defaultColDef={{
              suppressMenu: true,
            }}
            onGridReady={(event: GridReadyEvent) => {
              setGridApi(event.api);
              event.api.paginationSetPageSize(paginationPageSize);
            }}
            suppressCopyRowsToClipboard
            suppressScrollOnNewData
            suppressRowHoverHighlight
            suppressRowDrag
            suppressRowClickSelection
            suppressCellSelection
            suppressCsvExport
            suppressExcelExport
            suppressContextMenu
            domLayout="autoHeight"
            paginationPageSize={paginationPageSize}
            pagination
            suppressPaginationPanel
            applyColumnDefOrder
          >
            {columnDefs.map((column) => (
              <AgGridColumn {...column} key={column.field} />
            ))}
          </AgGridReact>
        </div>
      </TableWrapper>
      {paginationPageSize < rowData.length ? (
        <Pagination>
          {paginationPageSize}/{rowData.length}
          {paginationPageSize !== rowData.length && (
            <ApButtonText
              onClick={() => {
                const currentPageSize = gridApi.paginationGetPageSize();
                gridApi.paginationSetPageSize(currentPageSize + pageSize);
                setExtraRows(extraRows + 1);
              }}
            >
              SHOW MORE...
            </ApButtonText>
          )}
        </Pagination>
      ) : null}
    </Container>
  );
};

export default ProductsTable;
